import { RESTRICTED_PROFILE_CODES, PROFILE_CODES } from "./constants";

export const filterProfileCodesByOrg = (org: string) =>
  PROFILE_CODES.filter((profile) => !RESTRICTED_PROFILE_CODES[org]?.includes(profile.code));
